import { render } from "./TheMarkups.vue?vue&type=template&id=ff50287c"
import script from "./TheMarkups.vue?vue&type=script&lang=js"
export * from "./TheMarkups.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__